// Shared "support pathway not found" state, used by both the Manager
// pathway-scoped routes (detail, check-in, first-response, policy) and the HR
// detail route. Extracted from five near-identical local copies — a 404
// (wrong manager/org, deleted, bad id) reads and looks the same everywhere a
// manager or HR user can land on a `/cases/:id/...` route.
//
// The component/prop/route names stay `Case*` — PO 2026-08-06 renamed the
// user-facing WORD only; the API, DB and identifiers are still `case`.
//
// `backTo` and `reason` are both REQUIRED, deliberately with no default: the
// copy ("It may belong to another manager…") and the back-link target are
// role-specific, and a silent default here previously meant a caller could
// import this by its generic name and get Manager-specific wording on an
// HR/Employee screen with no compiler signal that anything was wrong. Making
// every caller state its own copy keeps that mistake visible in review
// instead of hidden in a prop default.
//
// No width/centering class of its own — callers render this bare inside
// their own page wrapper, so it inherits whatever layout (narrow centered
// column vs. wide dashboard section) that page already uses elsewhere.

import { Link } from 'react-router';

export function CaseNotFound({ backTo, reason }: { backTo: string; reason: string }) {
  return (
    <section className="space-y-3">
      <h1 className="text-2xl font-semibold">Support pathway not found</h1>
      <p className="text-muted-foreground">{reason}</p>
      <Link to={backTo} className="text-sm text-primary underline-offset-4 hover:underline">
        ← Back to support pathways
      </Link>
    </section>
  );
}
